import React, { memo } from 'react';
import type { NodeProps } from 'reactflow';

/**
 * Big, light-grey "watermark" step numeral shown in the left gutter of the
 * build view — one per cluster, numbering the execution steps top→bottom.
 * Positioned by clusterLayout to the left of each cluster region and centered
 * on it. Purely decorative (non-interactive).
 */
export const STEP_NUMBER_SIZE = 20;   // font size of the numeral
export const STEP_NUMBER_GUTTER = 28; // width of the gutter box the numeral sits in
export const STEP_NUMBER_MARGIN = 16; // gap between the gutter box and the cluster's left edge

export interface StepNumberNodeData {
  // Numeric for the cluster steps (1, 2, 3…); a string for the research
  // framing-question marker ("Q") that sits above step 1.
  number: number | string;
}

function StepNumberNodeComponent({ data }: NodeProps<StepNumberNodeData>) {
  return (
    <div
      aria-hidden
      style={{
        width: STEP_NUMBER_GUTTER,
        height: STEP_NUMBER_SIZE,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: STEP_NUMBER_SIZE,
        fontWeight: 700,
        lineHeight: 1,
        // Light-grey watermark — the design-system hairline neutral.
        color: 'var(--border)',
        userSelect: 'none',
        pointerEvents: 'none',
      }}
    >
      {data.number}
    </div>
  );
}

export default memo(StepNumberNodeComponent);
